import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 4h-6l-4-4-4 4H2v18h20V4zm-2 16H4V6h4.52l3.52-3.5L15.52 6H20v14zM18 8H6v10h12"
}), 'FilterFramesSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FilterFramesSharp.js
// module id = 3643
// module chunks = 2